import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { SRConnectIcon } from './icons/SRConnectIcon';

const StyledHeader = styled(Box)(({ theme }) => ({
    ...theme.typography.flexAlignCenter,
    backgroundColor: theme.palette.background.paper,
    borderBottom: theme.constants.border,
    gap: theme.spacing(1),
    justifyContent: 'center',
    padding: theme.spacing(1.5),
    '& .MuiSvgIcon-root': {
        height: 24,
        width: 24,
    },
}));

export const BrandHeader: React.FC = () => {
    return (
        <StyledHeader>
            <SRConnectIcon />
            <Typography fontWeight="normal" variant="h6">
                ScriptRunner Connect
            </Typography>
        </StyledHeader>
    );
};
